<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @apply="applyApi"
      @fullMember="fullMemberApi"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <b-button
          v-if="allow('A')"
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="openEditPage({ pageType: 'add' })"
        >
          <b-icon-plus></b-icon-plus>
          {{ $l('INDEX.btn_add') || '新增' }}
        </b-button>
        <!-- <el-badge
          v-if="allow('C')"
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            v-if="allow('C')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            :disabled="!checkedRowCount"
            @click="apply"
          >
            {{ '申请转正' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
        <el-badge
          v-if="allow('F')"
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            v-if="allow('F')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            :disabled="!checkedRowCount"
            @click="fullMember"
          >
            {{ '转正产品' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge> -->
      </PageHeader>

      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader },
  data() {
    return { usePage: true, checkedRows: [] }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomEvgSkuListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.clearCheckboxRow()
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-base-evgGoods-detail',
        params: { ...params, pageType },
        query,
      })
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    apply() {
      if (!this.checkedRowCount) {
        this.$message({
          message:
            this.$l('message_select_apply_sku') || '请选择需要申请转正的SKU',
          type: 'warning',
        })
        return
      }
      const listEvgSkuCode = this.checkedRows.map((row) => row.evgSkuCode)
      this.applyApi(listEvgSkuCode)
    },
    async applyApi(listEvgSkuCode) {
      const confirm = await this.$confirm(
        this.$l('confirm_do_you_want_apply_sku') || '是否要申请转正？',
        this.$l('confirm_title_apply_sku') || '确认信息',
        {
          confirmButtonText: this.$l('btn_apply_sku_confirm') || '确定',
          cancelButtonText: this.$l('btn_apply_sku_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgSkuApplyApi({ listEvgSkuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('message_apply_sku_error') || '申请失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('message_apply_sku_success') || '申请成功！',
        type: 'success',
      })
      this.reload()
    },
    async fullMember() {
      if (!this.checkedRowCount) {
        this.$message({
          message:
            this.$l('message_select_full_member_sku') || '请选择需要转正的SKU',
          type: 'warning',
        })
        return
      }
      const listEvgSkuCode = this.checkedRows.map((row) => row.evgSkuCode)
      this.fullMemberApi(listEvgSkuCode)
    },
    async fullMemberApi(listEvgSkuCode) {
      const confirm = await this.$confirm(
        this.$l('confirm_do_you_want_full_member_sku') || '是否要转正产品？',
        this.$l('confirm_title_full_member_sku') || '确认信息',
        {
          confirmButtonText: this.$l('btn_full_member_confirm') || '确定',
          cancelButtonText: this.$l('btn_full_member_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgSkuFullMemberApi({ listEvgSkuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('message_full_member_sku_error') || '转正失败！'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('message_full_member_sku_success') || '转正成功！',
        type: 'success',
      })
      this.reload()
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
